import EmailIcon from "Components/Icons/EmailIcon";
import { StyledAppBar } from "./styles";

const AppBar = () => {
    return (
        <StyledAppBar>
            <EmailIcon />
        </StyledAppBar>
    );
};

export default AppBar;
